import { render, staticRenderFns } from "./PeopleList.vue?vue&type=template&id=9aebf4f4&scoped=true&"
import script from "./PeopleList.vue?vue&type=script&lang=ts&"
export * from "./PeopleList.vue?vue&type=script&lang=ts&"
import style0 from "./PeopleList.vue?vue&type=style&index=0&id=9aebf4f4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aebf4f4",
  null
  
)

export default component.exports